/**
 * Le "void import" est utilisé pour importer des modules sans les utiliser directement dans ce fichier.
 * Cela permet de s'assurer que les composants sont enregistrés globalement ou que leurs effets secondaires sont exécutés.
 * Ici, nous importons la barre de navigation et le pied de page pour qu'ils soient disponibles dans l'application.
 */
void import('@core/components/template/navbar')
void import('@core/components/template/footer')

import '@comp/template/navbar/loadMe'
import '@comp/customHtml/Snackbar'

import { generateSkipLink } from '@core/components/template/SkipLink/generate.ts'

export const generateCoreElements = (document: Document) => {
  document.querySelector('body')?.insertAdjacentElement('afterbegin', generateSkipLink(document))
}
